import { MealCategory } from '@/domains';
import { authorizedApi } from '../network/authorized-api';

export const getMealCategories = (): Promise<MealCategory[]> => authorizedApi.get<MealCategory[]>(`/meal-categories`);
